export default {
  note: {
    title: 'Notes spéciales :',
    description: 'Nous ferons de notre mieux pour répondre aux demandes, mais ne pouvons pas modifier les prix.',
    placeholder: 'Ajouter une demande spéciale',
  },
  buttons: {
    add: '+ Ajouter un article',
    update_item: 'Mettre à jour',
    add_to_card: 'Ajouter au panier',
  },
  alcohol_warning: "Cet article est soumis à une restriction d'âge.",
  caffeine_warning: 'Teneur élevée en caféine. Déconseillé aux enfants, aux femmes enceintes ou allaitantes.{{value}}',
  error_messages: {
    product_unavailable: 'Épuisé !',
    item_not_added: "L'article n'a pas pu être ajouté. Veuillez réessayer.",
  },
  success_messages: {
    item_added: 'Article ajouté avec succès',
  },
};
